<template>
  <div class="main supervision-main">
    <statics-card type="fourClass"></statics-card>
    <el-card>
      <search-bar
        :search-params="searchParams"
        :store-id="storeId"
        @changeSearchParams="changeSearchParams"
        @search="search"
        type="fourClass"
      />
      <sale-list :data="list" type="fourClass" />
      <pagination
        @handlePage="handlePage"
        v-if="list && list.length"
        :total="total"
        :current-page="pageNo"
        :page-size="pageSize"
      />
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import staticsCard from './components/staticsCard';
import searchBar from './components/searchBar';
import saleList from './components/list';
import pagination from './components/pagination';

const type2Datetime = type => {
  switch (type) {
    case 'today': {
      return {
        orderStartTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'yesterday': {
      const yesterday = dayjs().subtract(1, 'days');
      return {
        orderStartTime: yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'week':
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'month':
      return {
        orderStartTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'year':
      return {
        orderStartTime: dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      };
    default:
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
  }
};

const today = type2Datetime('today');

export default {
  name: 'orderList',
  components: { staticsCard, searchBar, saleList, pagination },
  data() {
    return {
      searchParams: {
        drugName: '',
        orderId: '',
        registrationStatus: '',
        patchedStatus: null,
        isPrescription: null,
        dateRange: [today.orderStartTime, today.orderEndTime]
      },
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { pageSize } = this;
      const { dateRange } = this.searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ orderId: '', orderStartTime, orderEndTime, pageNo: 1, pageSize });
    },
    handlePage(pageNo) {
      const { searchParams, pageSize } = this;
      const { dateRange, ...rest } = searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ ...rest, orderStartTime, orderEndTime, pageNo, pageSize });
    },
    search() {
      const { searchParams, pageSize } = this;
      const { dateRange, ...rest } = searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ ...rest, orderStartTime, orderEndTime, pageNo: 1, pageSize });
    },
    changeSearchParams({ key, value }) {
      this.searchParams[key] = value;
    },
    fetchList(params) {
      const { storeId } = this;
      return Fetch.pc_inventory_supervision_sale_list({
        ...params,
        storeId
      }).then(res => {
        const { pageNo, totalCount, data } = res;
        this.pageNo = pageNo;
        this.total = totalCount;
        this.list = data;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
